import { Routes } from '@angular/router';
import { SeFeFrameRouterService } from 'se-fe-frame-router';
import { AccessDeniedComponent } from './core/components/access-denied/access-denied.component';
import { OrganizationResolver } from './core/resolvers/organization.resolver';
import { AppPermissionGuard } from './core/guards/app-permission.guard';
import { SeAuthGuardService } from 'se-fe-auth-support';
import { LaunchDarklyInitializer } from './core/resolvers/launch-darkly-initializer.resolver';
import { ViewReportAnalyticsGuard } from './core/guards/view-report-analytics.guard';
import { DefaultReportGuard } from './core/guards/default-report.guard';
import { HomePageComponent } from './home-page/home-page.component';

export const appRoutes: Routes = [
  { path: 'access-denied', component: AccessDeniedComponent },
  {
    path: '',
    data: {},
    canActivate: [SeFeFrameRouterService, SeAuthGuardService, AppPermissionGuard],
    resolve: { currentOrg: OrganizationResolver, ld: LaunchDarklyInitializer },
    children: [
      {
        path: '',
        pathMatch: 'full',
        // Let the parent frame-router guard restore deep links before choosing the default report.
        canActivate: [DefaultReportGuard],
        component: HomePageComponent,
      },
      {
        path: 'overview',
        loadChildren: () => import('./modules/overview/overview.module').then((m) => m.OverviewModule),
      },
      {
        path: 'payouts',
        data: { viewReportKey: 'payouts' },
        canActivate: [ViewReportAnalyticsGuard],
        loadChildren: () => import('./modules/payouts/payouts.module').then((m) => m.PayoutsModule),
      },
      {
        path: 'payouts/:payout_id',
        loadChildren: () => import('./modules/payout-detail/payout-detail.module').then((m) => m.PayoutDetailModule),
      },
      {
        path: 'refunds',
        data: { viewReportKey: 'refunds' },
        canActivate: [ViewReportAnalyticsGuard],
        loadChildren: () => import('./modules/refunds/refunds.module').then((m) => m.RefundsModule),
      },
      {
        path: 'sale-items',
        data: { viewReportKey: 'sale_items' },
        canActivate: [ViewReportAnalyticsGuard],
        loadChildren: () => import('./modules/sale-items/sale-items.module').then((m) => m.SaleItemsModule),
      },
      {
        path: 'sale-items/:sale_item_id',
        loadChildren: () =>
          import('./modules/sale-item-detail/sale-item-detail.module').then((m) => m.SaleItemDetailModule),
      },
      {
        path: 'receivables',
        data: { viewReportKey: 'receivables' },
        canActivate: [ViewReportAnalyticsGuard],
        loadChildren: () => import('./modules/receivables/receivables.module').then((m) => m.ReceivablesModule),
      },
      {
        path: 'adjustments',
        data: { viewReportKey: 'adjustments' },
        canActivate: [ViewReportAnalyticsGuard],
        loadChildren: () => import('./modules/adjustments/adjustments.module').then((m) => m.AdjustmentsModule),
      },
      {
        path: 'payments-received',
        data: { viewReportKey: 'payments_received' },
        canActivate: [ViewReportAnalyticsGuard],
        loadChildren: () =>
          import('./modules/payments-received/payments-received.module').then((m) => m.PaymentsReceivedModule),
      },
    ],
  },
];
